module.exports = __webpack_public_path__ + "static/media/visuel04.efcfe03b.jpg";